import React from 'react';

export default function Table({ header, content, className }) {
	return (
		<div>
			<div className='overflow-hidden  pt-8 px-10 pb-14'>
				<table className={`${className} w-full relative`}>
					<thead className='border-b border-[#2121217e]'>
						<tr>
							{header.map((headCol, key) => {
								return (
									<th key={key} className='font-normal'>
										<span>{headCol.title}</span>
										<img src={headCol.pic} className='inline' />
									</th>
								);
							})}
						</tr>
					</thead>
					<tbody className=' overflow-hidden'>
						{content.map((row, key) => {
							return (
								<tr
									key={key}
									className='odd:bg-purple-dark-1 overflow-hidden leading-10'
								>
									<td className='py-4'>{row.title}</td>
									<td className='py-4'>{row.adobe}</td>
									<td className='py-4'>{row.skyroom}</td>
									<td className='py-4'>{row.bbb}</td>
								</tr>
							);
						})}
						{/* <tr>
                            <th>1</th>
                            <td>Cy Ganderton</td>
                            <td>Quality Control Specialist</td>
                            <td>Blue</td>
                        </tr>

                        <tr>
                            <th>2</th>
                            <td>Hart Hagerty</td>
                            <td>Desktop Support Technician</td>
                            <td>Purple</td>
                        </tr>

                        <tr>
                            <th>3</th>
                            <td>Brice Swyre</td>
                            <td>Tax Accountant</td>
                            <td>Red</td>
                        </tr> */}
					</tbody>
				</table>
			</div>
		</div>
	);
}
